export class ProfileConstants {
  static INDUSTRIES = [
    'Business Services',
    'Education',
    'Energy & Utilities',
    'Financial Services',
    'Government',
    'Healthcare & Pharmaceuticals',
    'Insurance',
    'Legal',
    'Manufacturing',
    'Not for Profit',
    'Retail & Wholesale',
    'Technology',
    'Other'
  ];

  static COMPANY_SIZE = [
    '1 - 100',
    '101 - 500',
    '501 - 1000',
    '1000 +'
  ];

  static PAYMENT_STATUSES = [
    'free',
    'trial',
    'purchased',
    'recurring',
    'missing',
    'cancelled'
  ];

  static INSTANCE_STATUSES = [
    'active',
    'locked',
    'stopped',
    'terminated'
  ];

  static LOCATIONS = [
    'United States',
    'Afghanistan',
    'Albania',
    'Algeria',
    'American Samoa',
    'Andorra',
    'Angola',
    'Anguilla',
    'Antigua and Barbuda',
    'Argentina',
    'Armenia',
    'Aruba',
    'Australia',
    'Austria',
    'Azerbaijan',
    'The Bahamas',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belarus',
    'Belgium',
    'Belize',
    'Benin',
    'Bermuda',
    'Bhutan',
    'Bolivia',
    'Bosnia and Herzegovina',
    'Botswana',
    'Brazil',
    'Brunei',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Cambodia',
    'Cameroon',
    'Canada',
    'Cape Verde',
    'Cayman Islands',
    'Central African Republic',
    'Chad',
    'Chile',
    'People \'s Republic of China',
    'Republic of China',
    'Christmas Island',
    'Cocos(Keeling) Islands',
    'Colombia',
    'Comoros',
    'Congo',
    'Cook Islands',
    'Costa Rica',
    'Cote d\'Ivoire',
    'Croatia',
    'Cuba',
    'Cyprus',
    'Czech Republic',
    'Denmark',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Equatorial Guinea',
    'Eritrea',
    'Estonia',
    'Ethiopia',
    'Falkland Islands',
    'Faroe Islands',
    'Fiji',
    'Finland',
    'France',
    'French Polynesia',
    'Gabon',
    'The Gambia',
    'Georgia',
    'Germany',
    'Ghana',
    'Gibraltar',
    'Greece',
    'Greenland',
    'Grenada',
    'Guadeloupe',
    'Guam',
    'Guatemala',
    'Guernsey',
    'Guinea',
    'Guinea - Bissau',
    'Guyana',
    'Haiti',
    'Honduras',
    'Hong Kong',
    'Hungary',
    'Iceland',
    'India',
    'Indonesia',
    'Iran',
    'Iraq',
    'Ireland',
    'Israel',
    'Italy',
    'Jamaica',
    'Japan',
    'Jersey',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kiribati',
    'North Korea',
    'South Korea',
    'Kosovo',
    'Kuwait',
    'Kyrgyzstan',
    'Laos',
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Libya',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Macau',
    'Macedonia',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali',
    'Malta',
    'Marshall Islands',
    'Martinique',
    'Mauritania',
    'Mauritius',
    'Mayotte',
    'Mexico',
    'Micronesia',
    'Moldova',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Montserrat',
    'Morocco',
    'Mozambique',
    'Myanmar',
    'Nagorno - Karabakh',
    'Namibia',
    'Nauru',
    'Nepal',
    'Netherlands',
    'Netherlands Antilles',
    'New Caledonia',
    'New Zealand',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'Niue',
    'Norfolk Island',
    'Turkish Republic of Northern Cyprus',
    'Northern Mariana',
    'Norway',
    'Oman',
    'Pakistan',
    'Palau',
    'Palestine',
    'Panama',
    'Papua New Guinea',
    'Paraguay',
    'Peru',
    'Philippines',
    'Pitcairn Islands',
    'Poland',
    'Portugal',
    'Puerto Rico',
    'Qatar',
    'Romania',
    'Russia',
    'Rwanda',
    'Saint Barthelemy',
    'Saint Helena',
    'Saint Kitts and Nevis',
    'Saint Lucia',
    'Saint Martin',
    'Saint Pierre and Miquelon',
    'Saint Vincent and the Grenadines',
    'Samoa',
    'San Marino',
    'Sao Tome and Principe',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'Solomon Islands',
    'Somalia',
    'Somaliland',
    'South Africa',
    'South Ossetia',
    'Spain',
    'Sri Lanka',
    'Sudan',
    'Suriname',
    'Svalbard',
    'Swaziland',
    'Sweden',
    'Switzerland',
    'Syria',
    'Taiwan',
    'Tajikistan',
    'Tanzania',
    'Thailand',
    'Timor - Leste',
    'Togo',
    'Tokelau',
    'Tonga',
    'Transnistria Pridnestrovie',
    'Trinidad and Tobago',
    'Tristan da Cunha',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Turks and Caicos Islands',
    'Tuvalu',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Kingdom',
    'Uruguay',
    'Uzbekistan',
    'Vanuatu',
    'Vatican City',
    'Venezuela',
    'Vietnam',
    'British Virgin Islands',
    'Isle of Man',
    'US Virgin Islands',
    'Wallis and Futuna',
    'Western Sahara',
    'Yemen',
    'Zambia',
    'Zimbabwe'
  ];

  static VENDOR_SECURITY_AWARENESS_TRAINING = [
    'KnowBe4',
    'MediaPro',
    'Inspired E Learning',
    'SANS',
    'Rapid7',
    'Proofpoint (Wombat)',
    'Cofense (Phishme)'
  ];

  static VENDOR_THREAT_DETECTION = [
    'Rapid7',
    'Alien Vault',
    'IBM',
    'McAfee NSP',
    'Trend Micro TippingPoint',
    'Hillstone NIPS',
    'Darktrace Enterprise Immune System',
    'NSFocus NGIPS',
    'H3C SecBlade IPS',
    'Huawei NIP',
    'Entrust IoTrust Identity and Data Security',
    'Cisco Firepower NGIPS',
    'IDPS Vendor Features Chart'
  ];

  static VENDOR_NETWORK_MONITORING = [
    'ConnectWise Automate',
    'LogicMonitor',
    'Paessler PRTG Network Monitor',
    'ManageEngine OpManager',
    'Spiceworks Network Monitor',
    'Datadog',
    'Ruckus Wireless ZoneDirector 1200',
    'Idera Uptime Infrastructure Monitor',
    'Ipswitch WhatsUp Gold',
    'Vallum Halo Manager'
  ];

  static VENDOR_SPAM_FILTERS = [
    'Spam Bully',
    'Cleanmail',
    'Mailwasher Pro',
    'Avast',
    'eScan',
    'SpamSieve',
    'Hornetsecurity',
    'MSP-Solar Winds',
    'SpamTitan',
    'Zero Spam',
    'Zero Bounce',
    'Symantec',
    'SpamPhobia',
    'TopSec',
    'Smart Protection-Trend Micro',
    'MailWasher-Trust',
    'SpamFighter',
    'Comodo Dome Antispam',
    'Mailcleaner',
    'MailChannels Cloud',
    'Spambrella',
    'SpamHero',
    'SecureTide-Appriver',
    'MailEssentials- GFI',
    'Spameo',
    'Blade-Checkpoint',
    'Altospam',
    'CanIt Pro-Roaring Penguin',
    'EveryCloud',
    'modusCloud-Vircom',
    'Sentinal-Barracuda',
    'Content Catcher-Clearnetwork',
    'Inumbo',
    'Privatize-Introviz',
    'SpamStopsHere-Greenview Data',
    'Vade Secure'
  ]

  static VENDOR_WEB_BLOCKER = [
    'Barracuda Web Blocker',
    'Website Blocker',
    'Block Site',
    'StayFocusd',
    'Nanny',
    'K9 Web Protection',
    'Aobo Website Blocker',
    'InterGuard',
    'Net Nanny',
    'Truevine'
  ];

  static VENDOR_WI_FI = [
    '4ipnet',
    'Adtran/BlueSocket',
    'Aerohive',
    'AirTight',
    'Air802',
    'Alaxala Networks',
    'Allied Telesis[5]',
    'Altai Technologies',
    'Alvarion',
    'Aruba acquired by HPE',
    'Asus',
    'Avaya',
    'Belkin',
    'Billion Electric',
    'Buffalo Technology',
    'Cambium Networks',
    'Ceragon',
    'Cerio',
    'CHANGE Networks',
    'Cisco',
    'Compex Systems',
    'Cradlepoint',
    'D-Link',
    'Edgewater Wireless',
    'EnGenius',
    'Enterasys acquired by Extreme',
    'Ericsson',
    'Extreme Networks',
    'Fortinet',
    'H3C Technologies',
    'HPE',
    'Juniper - acquired Trapeze',
    'Ligowave',
    'LANCOM Systems',
    'Linksys - acquired by Belkin',
    'Loopcomm',
    'Meraki - acquired by Cisco',
    'Meru acquired by Fortinet',
    'MikroTik',
    'mojonetworks',
    'Motorola',
    'NEC',
    'Netgear',
    'Nokia Networks',
    'Open Mesh acquired by Datto',
    'Proxim',
    'Redline Telecommunications',
    'RF Elements',
    'Ruckus - acquired by Brocade; to be acquired by ARRIS',
    'Sierra Wireless',
    'Samsung',
    'SMC Networks',
    'Teltonika',
    'TP-Link',
    'Ubiquiti',
    'WatchGuard',
    'Xirrus - acquired by Riverbed',
    'Zcomax Technologies',
    'ZyXEL'
  ];

  static VENDOR_SURGE_PROTECTION = [
    'Tripp Lite',
    'Belkin',
    'Furman',
    'APC',
    'Accell',
    'Ditek',
    'Media5',
    'Anker',
    'Stanley',
    'Kennsington'
  ];

  static VENDOR_CLOUD_BACKUP_SMALL = [
    'IDrive	',
    'Acronis True Image	',
    'SpiderOak ONE	',
    'SOS Online Backup	',
    'Backblaze	',
    'Livedrive',
    'Carbonite	',
    'OpenDrive	',
    'Norton Online Backup',
    'MozyHome'
  ];

  static VENDOR_CLOUD_BACKUP_ENTERPRISE = [
    'Zetta  Affordable',
    'MozyPro',
    'CrashPlan ',
    'eVault',
    'IDrive',
    'Carbonite',
    'DataBarracks',
    'SecurStore',
    'LiveVault',
    'BackupMyInfo',
    'DSCorp.net',
    'GlobalDataVault',
    'Backup',
    'Intronis Fast',
    'StorageGuardian',
    'Storagepipe',
    'OpenDrive',
    'RemoteDataBackups',
    'DriveHQ',
    'OnCoreIT'
  ];

  static VENDOR_CLOUD_BACKUP_MSP = [
    'ConnectWise',
    'Unitrends',
    'Dell AppAssure',
    'StorageCraft',
    'Zetta.net',
    'Evault',
    'AhSay',
    'Arkeia',
    'Axcient',
    'ShadowProtect',
    'Arcserve'
  ];

}